import * as React from 'react'
import { useState, useCallback } from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'
import { uniformUrl } from '../../../helpers/StringHelpers'
import DropdownMenuLink from './DropdownMenuLink'
import PropTypes from 'prop-types'
 
const BrandLetterSelector = ({ onMenuLinkClicked }) => {
  const [currentLetter, setLetter] = useState(null)
  const { watchBrands } = useStaticQuery(
    graphql`
      query {
        watchBrands: watchBrandsCategories {
          name
          url: urlPath
        }
      }
    `
  )
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVXYZ'.split('')
  const letterMapping = {}
  letters.forEach(
    letter =>
      (letterMapping[letter] = watchBrands.filter(
        brand =>
          (brand.name || '').trim().length > 1 && brand.name.trim()[0].toUpperCase() === letter
      ))
  )

  const hasCurrentLetter =
    currentLetter && letterMapping[currentLetter] && letterMapping[currentLetter].length > 0
  const featured = [
    { name: 'Richard Mille', url: '/fine-watches/other-watches-brands/richard-mille' },
    { name: 'Breguet', url: '/fine-watches/other-watches-brands/breguet' },
    { name: 'Girard Perregaux', url: '/fine-watches/other-watches-brands/girard-perregaux' },
    { name: 'Corum', url: '/fine-watches/other-watches-brands/corum-watches-for-sale' },
    { name: 'Piaget', url: '/fine-watches/other-watches-brands/piaget' },
    { name: 'Panerai', url: '/fine-watches/other-watches-brands/panerai' },
    { name: 'Tag Heuer', url: '/fine-watches/other-watches-brands/used-tag-heuer-watches' },
    { name: 'Roger Dubuis', url: '/fine-watches/other-watches-brands/roger-dubuis' },
    { name: 'Vacheron Constantin', url: '/fine-watches/other-watches-brands/vacheron-constantin' },
  ]

  const onLetterClick = useCallback(
    e => {
      e.preventDefault()
      setLetter(e.target.getAttribute('data-letter'))
    },
    []
  )

  return (
    <div className="col-span-2 hidden lg:grid lg:grid-flow-row lg:grid-cols-2">
      <div className="col-span-1">
        <Link className="text-black hover:text-red-600 font-bold" to="/fine-watches/">
          SEARCH BY BRAND
        </Link>
        <div className="shop-by-brand -mx-[10px] grid max-w-max grid-flow-row grid-cols-7 py-2 uppercase">
          {letters.map(letter => (
            <button
              key={letter}
              className={
                'h-[30px] w-[30px] text-center rounded-lg mb-1 flex justify-center items-center ' +
                (letterMapping[letter].length > 0
                  ? 'hover:font-bold hover:text-red-600 border border-transparent  hover:border-red-600'
                  : 'text-gray-400')
              }
              data-letter={letter}
              onClick={onLetterClick}
            >
              {letter}
            </button>
          ))}
        </div>
        <DropdownMenuLink onClick={onMenuLinkClicked} to="/all-watch-brands/">
          VIEW ALL BRANDS
        </DropdownMenuLink>
        <br />
        <DropdownMenuLink onClick={onMenuLinkClicked} to="/find-your-watch/">
          FIND YOUR WATCH
        </DropdownMenuLink>
      </div>

      <div className=" col-span-1 flex flex-col">
        <span className="mt-7 block w-full font-bold lg:mt-0">
          {hasCurrentLetter ? currentLetter : 'FEATURED BRANDS'}
        </span>
        {(hasCurrentLetter ? letterMapping[currentLetter] : featured).map(
          ({ name, url }, index) => (
            <DropdownMenuLink
              onClick={onMenuLinkClicked}
              key={`${url.replace('/', '-')}-${index}`}
              to={uniformUrl(url)}
            >
              {name}
            </DropdownMenuLink>
          )
        )}
      </div>
    </div>
  )
}

BrandLetterSelector.propTypes = {
  onMenuLinkClicked: PropTypes.func,
}

export default BrandLetterSelector
